function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Upload } from 'mkui-fd';
import PropTypes from 'prop-types';
import UploadList from '../UploadList';

var BaseUpload = /*#__PURE__*/function (_Component) {
  _inherits(BaseUpload, _Component);

  _createClass(BaseUpload, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('fileList' in nextProps) {
        return {
          fileList: nextProps.fileList || []
        };
      }

      return null;
    }
  }]);

  function BaseUpload(props) {
    var _this;

    _classCallCheck(this, BaseUpload);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseUpload).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (info) {
      var fileList = info.fileList || [];

      if (!('fileList' in _this.props)) {
        _this.setState({
          fileList: fileList
        });
      }

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(info);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleRemove", function (file) {
      var upload = _this.upload.current;
      upload.handleManualRemove(file);
    });

    _this.state = {
      fileList: props.fileList || props.defaultFileList || []
    };
    _this.upload = React.createRef();
    return _this;
  }

  _createClass(BaseUpload, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          defaultFileList = _this$props.defaultFileList,
          showPreviewIcon = _this$props.showPreviewIcon,
          showDownloadIcon = _this$props.showDownloadIcon,
          mode = _this$props.mode,
          args = _objectWithoutProperties(_this$props, ["prefixCls", "defaultFileList", "showPreviewIcon", "showDownloadIcon", "mode"]);

      var fileList = this.state.fileList;
      return React.createElement("div", {
        className: prefixCls
      }, React.createElement(Upload, _extends({}, args, {
        ref: this.upload,
        defaultFileList: defaultFileList,
        fileList: fileList,
        onChange: this.onChange,
        showUploadList: false
      })), React.createElement(UploadList, {
        dataList: fileList,
        onRemove: this.handleRemove,
        showPreviewIcon: showPreviewIcon,
        showDownloadIcon: showDownloadIcon,
        mode: mode
      }));
    }
  }]);

  return BaseUpload;
}(Component);

_defineProperty(BaseUpload, "propTypes", {
  mode: PropTypes.string,
  prefixCls: PropTypes.string,
  showPreviewIcon: PropTypes.bool,
  showDownloadIcon: PropTypes.bool
});

_defineProperty(BaseUpload, "defaultProps", {
  mode: 'vertical',
  prefixCls: 'mkui-enhanced-upload',
  defaultFileList: [],
  showPreviewIcon: true,
  showDownloadIcon: true,
  onChange: function onChange() {},
  onRemove: function onRemove() {}
});

export { BaseUpload as default };
//# sourceMappingURL=BaseUpload.js.map
